import { translate } from '@components/i18n';
import { CustomerResponse } from '@models/customer';
import { customerSelector } from '@redux/slices/order';
import { Col, Row, Typography } from 'antd';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';

type CardHeaderProps = {
    customer?: CustomerResponse
}


export const CardHeader: React.FC<CardHeaderProps> = memo(({ customer }) => {
    const { customer: customerDefault } = useSelector(customerSelector);

    const cust = customer || customerDefault

    return (
        <Col>
            <Row style={{ paddingLeft: 10 }}>
                <Typography.Text
                    style={{
                        fontWeight: 300,
                        fontSize: 16,
                    }}
                >
                    {translate('forms.labels.client')}:
                    <Typography.Text strong style={{ marginLeft: 5 }}>
                        {cust?.name}
                    </Typography.Text>
                </Typography.Text>
            </Row>
            <Row style={{ paddingLeft: 10 }}>
                <Typography.Text style={{ fontWeight: 300, fontSize: 16 }}>
                    {translate('forms.labels.cnpj')}:
                    <Typography.Text strong style={{ marginLeft: 5 }}>
                        {cust?.cnpj}
                    </Typography.Text>
                </Typography.Text>
            </Row>
        </Col>
    );
});
